import React from 'react'

const ReferralIcon = props => (
  <svg
    width={24}
    height={24}
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="users"
    className="svg-inline--fa fa-users fa-w-18"
    role="img"
    viewBox="0 0 576 512"
    {...props}
  >
    {/* <path
      fill="currentColor"
      d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    /> */}

    <path
      fill="currentColor"
      d="m460.943 126.795c9.954-10.714 16.057-25.052 16.057-40.795 0-33.084-26.916-60-60-60s-60 26.916-60 60c0 15.743 6.103 30.081 16.057 40.795-30.32 15.887-51.057 47.668-51.057 84.205v30c0 8.284 6.716 15 15 15h160c8.284 0 15-6.716 15-15v-30c0-36.537-20.737-68.318-51.057-84.205zm-43.943-70.795c16.542 0 30 13.458 30 30s-13.458 30-30 30-30-13.458-30-30 13.458-30 30-30zm65 170h-130v-15c0-35.841 29.159-65 65-65s65 29.159 65 65z"
    />
    <path
      fill="currentColor"
      d="m190 241v-30c0-36.537-20.737-68.318-51.057-84.205 9.954-10.714 16.057-25.052 16.057-40.795 0-33.084-26.916-60-60-60s-60 26.916-60 60c0 15.743 6.103 30.081 16.057 40.795-30.32 15.887-51.057 47.668-51.057 84.205v30c0 8.284 6.716 15 15 15h160c8.284 0 15-6.716 15-15zm-95-185c16.542 0 30 13.458 30 30s-13.458 30-30 30-30-13.458-30-30 13.458-30 30-30zm65 170h-130v-15c0-35.841 29.159-65 65-65s65 29.159 65 65z"
    />
    <path
      fill="currentColor"
      d="m427.606 300.394c-5.858-5.858-15.355-5.858-21.213 0l-60 60c-5.858 5.858-5.858 15.355 0 21.213s15.355 5.858 21.213 0l34.394-34.394v108.787h-292v-145c0-8.284-6.716-15-15-15s-15 6.716-15 15v160c0 8.284 6.716 15 15 15h322c8.284 0 15-6.716 15-15v-123.787l34.394 34.394c5.858 5.858 15.355 5.858 21.213 0s5.858-15.355 0-21.213z"
    />
  </svg>
)

export default ReferralIcon
